import { ItemListingParams } from '../structuredMappers/itemListing';
import { OrganizationMapperResult } from '../structuredMappers/organization';
import { generateUrl } from '../utils';

export const rawToBreadcrumbs = (
  data: {
    title: string;
    fullPath: string;
  }[],
  organization: OrganizationMapperResult
): ItemListingParams => ({
  items: data.map((item, index) => ({
    name: item.title,
    item: generateUrl(item.fullPath, organization.url),
    position: index + 1,
  })),
});
